export const COUPONS_LANDING_AMPLITUDE_PAGE_NAME = 'Coupons Landing';
